import { render, staticRenderFns } from "./data-source-dialog.vue?vue&type=template&id=1df41e1c"
import script from "./data-source-dialog.vue?vue&type=script&lang=js"
export * from "./data-source-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports